<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <b-img src="img/brand/easydrive2_logo.jpeg" />
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input alternative
                              class="mb-3"
                              name="Organisation"
                              :rules="{required: true}"
                              prepend-icon="ni ni-briefcase-24"
                              placeholder="Organisation"
                              v-model="model.organisation">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              name="User name"
                              :rules="{required: true}"
                              prepend-icon="ni ni-laptop"
                              placeholder="User name"
                              v-model="model.username">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              name="Password"
                              :rules="{required: true, min: 6}"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              placeholder="Password"
                              v-model="model.password">
                  </base-input>

                  <b-form-checkbox v-model="model.rememberMe">Remember me</b-form-checkbox>
                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">Sign in</base-button>
                  </div>
                  <div class="form-group">
                    <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/dashboard" class="text-light"><small>Forgot password?</small></router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

  export default {
    data() {
      return {
        model: {
          organisation: '',
          username: '',
          password: '',
          rememberMe: false,
        },
        message: ''
      };
    },
    computed: {
      loggedIn() {
        return this.$store.state.auth.status.loggedIn;
      }
    },
    created() {
      if (this.loggedIn) {
        this.$router.push('/overview').catch(()=>{});
      }
    },
    methods: {
      onSubmit() {
        let user = {
            organisation: this.model.organisation,
            username: this.model.username,
            password: this.model.password
        }
        this.$store.dispatch('auth/login', user).then(
          () => {
            if (this.loggedIn) {
              this.$router.push('/overview').catch(()=>{});
            }
          },
          error => {
            this.loading = false;
            this.message =
              (error.response && error.response.data && error.response.data.message) ||
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
        );
      }
    }
  };
</script>
